import React, { useState } from "react";
import { Auth } from "aws-amplify";
import AddClient from "./AddClient";
import LookUp from "./LookUp";
import RenewClient from "./RenewClient";

type View = "menu" | "add-client" | "lookup" | "renew";

interface DashboardProps {
  onLogout: () => void;
}

export default function Dashboard({ onLogout }: DashboardProps) {
  const [view, setView] = useState<View>("menu");

  const handleLogout = async () => {
    await Auth.signOut();
    onLogout();
  };

  if (view === "add-client") {
    return <AddClient onBack={() => setView("menu")} />;
  }

  if (view === "lookup") {
    return <LookUp onBack={() => setView("menu")} />;
  }

  if (view === "renew") {
    return <RenewClient onBack={() => setView("menu")} />;
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.header}>
          <h1 style={styles.title}>Tableau de bord partenaire</h1>
          <button onClick={handleLogout} style={styles.logoutBtn}>
            Se deconnecter
          </button>
        </div>
        <p style={styles.subtitle}>Que souhaitez-vous faire ?</p>
        <div style={styles.actions}>
          <div>
            <p style={styles.description}>
              Creer un nouveau compte client et l'associer a une organisation partenaire.
            </p>
            <button
              onClick={() => setView("add-client")}
              style={styles.actionBtn}
            >
              <span style={styles.actionIcon}>+</span>
              <span>Ajouter un client</span>
            </button>
          </div>
          <div>
            <p style={styles.description}>
              Rechercher une organisation et ses utilisateurs. Transferer un utilisateur vers une autre sous-organisation.
            </p>
            <button
              onClick={() => setView("lookup")}
              style={styles.actionBtn}
            >
              <span style={styles.actionIcon}>&#128269;</span>
              <span>Consulter</span>
            </button>
          </div>
          <div>
            <p style={styles.description}>
              Renouveler les credits d'un client existant. Consulter et modifier le nombre de credits achetes.
            </p>
            <button
              onClick={() => setView("renew")}
              style={styles.actionBtn}
            >
              <span style={styles.actionIcon}>&#8635;</span>
              <span>Renouveler un client</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    backgroundColor: "#f5f5f5",
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: 8,
    padding: 40,
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    width: 540,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 8,
  },
  title: {
    margin: 0,
    fontSize: 24,
    color: "#333",
  },
  subtitle: {
    color: "#666",
    marginBottom: 24,
  },
  logoutBtn: {
    padding: "8px 16px",
    backgroundColor: "transparent",
    border: "1px solid #ddd",
    borderRadius: 6,
    fontSize: 13,
    cursor: "pointer",
    color: "#666",
  },
  actions: {
    display: "flex",
    flexDirection: "column" as const,
    gap: 16,
  },
  description: {
    fontSize: 13,
    color: "#888",
    margin: "0 0 6px 0",
  },
  actionBtn: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "16px 20px",
    backgroundColor: "#f9fafb",
    border: "1px solid #e5e7eb",
    borderRadius: 8,
    fontSize: 15,
    cursor: "pointer",
    textAlign: "left" as const,
    width: "100%",
  },
  actionBtnDisabled: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "16px 20px",
    backgroundColor: "#f9fafb",
    border: "1px solid #e5e7eb",
    borderRadius: 8,
    fontSize: 15,
    cursor: "not-allowed",
    textAlign: "left" as const,
    opacity: 0.5,
    width: "100%",
  },
  actionIcon: {
    fontSize: 20,
    fontWeight: 700,
    color: "#4f46e5",
    width: 28,
    textAlign: "center" as const,
  },
  badge: {
    marginLeft: "auto",
    fontSize: 11,
    backgroundColor: "#e5e7eb",
    color: "#6b7280",
    padding: "2px 8px",
    borderRadius: 10,
  },
};
